import GoogleLogo from "../svgs/GoogleLogo";
import AppleLogo from "../svgs/AppleLogo";

type SocialButtonProps = {
  type: "google" | "apple";
  text: string;
  disabled: boolean;
  onClick: () => any;
};

const SocialButton = ({ type, text, disabled, onClick }: SocialButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="authentication__social__button authentication__social__button--google"
    >
      {type === "google" ? (
        <GoogleLogo className={"authentication__social__icon"} />
      ) : (
        <AppleLogo className={"authentication__social__icon"} />
      )}
      {text}
    </button>
  );
};

export default SocialButton;
